import script from "./MoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreButton.vue?vue&type=script&setup=true&lang=js"

import "./MoreButton.vue?vue&type=style&index=0&id=1e5f2e6a&lang=scss"

const __exports__ = script;

export default __exports__